(function () {
  function formatMoney(amountInCents, count, currency) {
    var per = amountInCents / 100 / count;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(per);
    } catch (e) {
      return '$' + per.toFixed(2);
    }
  }

  function update(root, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    if (variant.price <= 0) {
      root.style.display = 'none';
      return;
    }
    root.style.display = '';

    var count = parseInt(root.getAttribute('data-installments'), 10) || 4;
    var currency = root.getAttribute('data-currency') || 'USD';
    var amountEl = root.querySelector('[data-installments-amount]');
    if (amountEl) {
      amountEl.textContent = formatMoney(variant.price, count, currency);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-installments-payment]');
    if (!roots.length) return;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      roots.forEach(function (root) {
        update(root, variant);
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', init);
})();
